import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News010() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.10.p1'),
        t('news:news.10.p2'),
        t('news:news.10.p3'),
        t('news:news.10.p4'),
        t('news:news.10.p5'),
        t('news:news.10.p6'),
        t('news:news.10.p7'),
		t('news:news.10.p8'),
		t('news:news.10.p9'),
		t('news:news.10.p10')
    ]

    const newsImage = [
        "news010-img1.jpg",
        "news010-img2.jpg",
        "news010-img3.jpg",
        "news010-img4.jpg",
		"news010-img5.jpg",
		"news010-img6.jpg"
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2026-06-19"
                headline={t('news:headline.10')}
            />
        </div>
    )
}